export default __webpack_public_path__ + "static/media/1.4b2e4d04.jpg";